import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=655b94d6&scoped=true&"
import script from "./ProgramsList.vue?vue&type=script&lang=ts&"
export * from "./ProgramsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramsList.vue?vue&type=style&index=0&id=655b94d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b94d6",
  null
  
)

export default component.exports